(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coffee-made-simple"] && !Shopify.designMode) return;
  try {
    

(() => {
function init(root) {
 if(root.dataset.initialized) return; root.dataset.initialized='true';
 const cards=[...root.querySelectorAll('.cms-card')];
 const search=root.querySelector('[data-cms-search]');
 if(search) search.addEventListener('input',()=>{
  const term=search.value.trim().toLocaleLowerCase(); let shown=0;
  cards.forEach(card=>{card.hidden=!card.textContent.toLocaleLowerCase().includes(term);if(!card.hidden)shown++;});
  const status=root.querySelector('[data-cms-status]');
  if(status){status.hidden=shown!==0;}
 });
 root.querySelectorAll('details').forEach(detail=>detail.addEventListener('toggle',()=>{
  if(detail.open){
   root.querySelectorAll('details[open]').forEach(other=>{if(other!==detail)other.open=false;});
   const player=detail.querySelector('[data-cms-player]');
   const template=detail.querySelector('template');
   if(player&&template&&!player.children.length) player.append(template.content.cloneNode(true));
  } else {const player=detail.querySelector('[data-cms-player]');if(player)player.replaceChildren();}
 }));
}
document.querySelectorAll('[data-cms]').forEach(init);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-cms]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
